document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('featured-product-form')) {
    customElements.define(
      'featured-product-form',
      class FeaturedProductForm extends customElements.get('product-form') {
        formatMoney(cents) {
          return new Intl.NumberFormat(undefined, {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(cents / 100);
        }
        constructor() {
          super();
          this.variantPicker = this.querySelectorAll(`[data-featured-product-variant-picker]`);
          this.variantPicker.forEach((picker) => {
            picker.addEventListener('change', this.handleVariantChange.bind(this));
          });
          this.sectionElement = this.querySelector(`product-form`);

          const checkedVariant = this.querySelector('[data-featured-product-variant-picker]:checked');

          if (checkedVariant) {
            const variant = JSON.parse(checkedVariant.dataset.variant);

            window.theme = window.theme || {};
            window.theme.currentVariant = variant;

            // const button = this.querySelector('[name="add"]');
            // const priceEl = button?.querySelector('.add-to-cart-price');
            // if (priceEl) {
            //   priceEl.textContent = `- ${this.formatMoney(variant.price)}`;
            // }
          }
          if (this.hasAttribute('data-sync-product-selection')) {
            this.addEventListener('click', (event) => {
              const button = event.target.closest('[data-compare-button-id]');
              if (!button || !this.contains(button)) return;
              // Own the complete selection here so the legacy toggle cannot
              // clear the radio after its product was selected again.
              event.stopPropagation();
              this.selectProduct(button.dataset.compareButtonId);
            }, true);
            this.selectProduct(this.querySelector('[data-compare-product-id].active')?.dataset.compareProductId);
          }
        }
        selectProduct(productId) {
          const cards = [...this.querySelectorAll('.quickview-variant-list[data-compare-product-id]')];
          const activeCard = cards.find((card) => card.dataset.compareProductId === productId);
          if (!activeCard) return;
          cards.forEach((card) => {
            const active = card === activeCard;
            card.classList.toggle('active', active);
            card.querySelectorAll('[data-featured-product-variant-picker]').forEach((input) => {
              if (input.checked) card.dataset.selectedVariant = input.value;
              input.checked = false;
              // A radio the theme disabled (no single selling plan) stays disabled.
              input.disabled = !active || input.hasAttribute('aria-disabled');
            });
          });
          this.querySelectorAll('[data-compare-button-id]').forEach((button) => {
            const active = button.dataset.compareButtonId === productId;
            button.classList.toggle('active', active);
            button.setAttribute('aria-pressed', String(active));
          });
          this.querySelectorAll('[data-selection-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.selectionPanel !== productId;
            if (!panel.hidden) panel.querySelector('.pdp-gallery-main')?.swiper?.update();
          });
          const inputs = [...activeCard.querySelectorAll('[data-featured-product-variant-picker]')]
            .filter((input) => !input.disabled);
          const selected = inputs.find((input) => input.value === activeCard.dataset.selectedVariant) ||
            inputs.find((input) => JSON.parse(input.dataset.variant).available) || inputs[0];
          if (selected) {
            selected.checked = true;
            selected.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        handleVariantChange(evt) {
          this.updateFormInput(this.form, evt.target);
          this.handleOneTimePurchase(evt);
          const variant = JSON.parse(evt.target.dataset.variant);

          window.theme = window.theme || {};
          window.theme.currentVariant = variant;

          if (this.hasAttribute('data-sync-product-selection')) {
            const card = evt.target.closest('[data-compare-product-id]');
            this.querySelector('.product__title').textContent = card.dataset.productTitle;
            this.querySelector('product-info').dataset.url = card.dataset.productUrl;
            this.form.querySelector('[name="product-id"]').value = card.dataset.compareProductId;
            this.sectionElement.dataset.firmhouseFrequency = evt.target.dataset.firmhouseShipment;
            this.querySelector('[name="add"]').disabled = !variant.available;
            const allocation = variant.selling_plan_allocations.find(
              (plan) => String(plan.selling_plan_id) === evt.target.dataset.sellingPlanId
            );
            const price = new Intl.NumberFormat(document.documentElement.lang || 'nl', {
              style: 'currency', currency: this.dataset.currency,
            }).format((allocation?.price ?? variant.price) / 100);
            this.querySelectorAll('.add-to-cart-price').forEach((element) => {
              element.textContent = `– ${price}`;
            });
            return;
          }

          const submitButton = this.querySelector('[name="add"]');
          const oneTimeButton = this.querySelector('.product-form__one-time-button');
          const priceEls = [
            submitButton?.querySelector('.add-to-cart-price'),
            oneTimeButton?.querySelector('.add-to-cart-price'),
          ].filter(Boolean);

          priceEls.forEach((el) => {
            el.textContent = `- ${this.formatMoney(variant.price)}`;
          });
        }
        updateFormInput(form, target) {
          form.querySelector(`[name="id"]`).value = target.value;
          form.querySelector(`[name="selling_plan"]`).value = target.dataset.sellingPlanId;
        }
        handleOneTimePurchase(evt) {
          if (evt.target.dataset.firmhousePopup) {
            this.sectionElement.classList.add('hide-normal-buy-button');
          } else {
            this.sectionElement.classList.remove('hide-normal-buy-button');
          }
        }
        onSubmitHandler(evt) {
          super.onSubmitHandler(evt);
        }
        handleErrorMessage(errorMessage = false) {
          super.handleErrorMessage(errorMessage);
        }
      },
    );
  }
});
